// スライダー

import { Splide } from '@splidejs/splide';

const campaignBannerOptions = {
  autoplay: true,
  interval: 4000,
  speed: 2000,
  arrows: false,
  pagination: true,
  type: 'slide',
  rewind: true,
  perMove: 1,
  pauseOnFocus: false,
  pauseOnHover: true,
  updateOnMove: true,
};

const campaignBannerSlider = document.querySelector('.campaignBannerSlider');

if(campaignBannerSlider) {
  const campaignBannerSplide = new Splide('.campaignBannerSlider', campaignBannerOptions);
  campaignBannerSplide.mount();
}